import script from "./ToastComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToastComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ToastComponent.vue?vue&type=style&index=0&id=355fbe26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355fbe26"]])

export default __exports__